import { orchestrator } from 'satcheljs';
import setIsRemovingDomain from '../mutators/setIsRemovingDomain';
import { deleteDomain } from '../services/deleteDomain';
import { getDomainState } from '../actions/getDomainState';
import { removeDomain } from '../actions/removeDomain';
import { traceRemoveDomainButtonClick } from '../utils/domainOptionTracer';

export default orchestrator(removeDomain, async function removeDomain() {
    traceRemoveDomainButtonClick();
    setIsRemovingDomain(true);
    await deleteDomain();
    setIsRemovingDomain(false);
    await getDomainState();
});
